import ReactApexChart from 'react-apexcharts';

const Line = ({ categories, series, height = 350 }) => {

  const themeFont = getComputedStyle(document.body)
    .getPropertyValue('--bs-body-font-family')
    .trim();
  const inverse = getComputedStyle(document.body).getPropertyValue('--bs-inverse').trim();
  const inverseRgb = getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim();
  const themeFontWeight = getComputedStyle(document.body)
    .getPropertyValue('--bs-body-font-weight')
    .trim();
  const gray500 = getComputedStyle(document.body).getPropertyValue('--bs-gray-500').trim();
  // const orange = getComputedStyle(document.body).getPropertyValue('--bs-warning').trim();
  const borderColor = getComputedStyle(document.body).getPropertyValue('--bs-border-color').trim();
  const themeColorRgb = getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb').trim();
  const gray600 = getComputedStyle(document.body).getPropertyValue('--bs-gray-600').trim();
  const pink = getComputedStyle(document.body).getPropertyValue('--bs-pink').trim();
  const themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
 



  const LineOptions = {
    chart: { shadow: { enabled: true, color: 'rgba('+ inverseRgb +', .5)', top: 18, left: 7, blur: 10, opacity: 1 }, toolbar: { show: false } },
    // title: { text: 'Average High & Low Temperature', align: 'center', style: { fontSize:  '14px', fontWeight:  'bold', fontFamily:  themeFont, color: inverse } },
    colors: [themeColor, gray500],
    // dataLabels: { enabled: true, background: { enabled: true, padding: 4, borderRadius: 2, borderWidth: 0, opacity: 0.9, dropShadow: { enabled: false } } },
    stroke: { curve: 'smooth', width: 4 },
    grid: { borderColor: borderColor, row: { colors: ['rgba('+ inverseRgb +', .25)', 'transparent'], opacity: 0.5 } },
    markers: { size: 4 },
  
    // fill: {
    //   opacity: [0.85, 1],
    // },
    xaxis: { 
      categories,
      // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
      axisBorder: { show: true, color: 'rgba('+ inverseRgb +', .25)', height: 1, width: '100%', offsetX: 0, offsetY: -1 },
      axisTicks: { show: true, borderType: 'solid', color: 'rgba('+ inverseRgb +', .25)', height: 6, offsetX: 0, offsetY: 0 },
      labels: { style: { colors: inverse, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight, cssClass: 'apexcharts-xaxis-label' } }
    },
    yaxis: { 
      // min: 5, max: 40,
      labels: { style: { colors: inverse, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight, cssClass: 'apexcharts-xaxis-label' } }
    },
    legend: { show: true, position: 'top', offsetY: -10, horizontalAlign: 'right', floating: true, fontFamily: themeFont, labels: { colors: inverse } }
    
  };
  var lineChartData = [
    { name: 'High - 2024', data: [28, 29, 33, 36, 32, 32, 33]  }, 
    { name: 'Low - 2024', data: [12, 11, 14, 18, 17, 13, 13] }
  ];
  
  // var lineChartData =[
  //   {
  //     name: 'المدفوعات',
  //     data: [2000, 1500, 1800, 2200, 2500, 2700], // المدفوعات الشهرية
  //   },
  //   {
  //     name: 'المصروفات',
  //     data: [1000, 1200, 1100, 1500, 1300, 1400], // المصروفات الشهرية
  //   },
  // ]
  

       

  // return <ReactApexChart options={LineOptions} series={lineChartData} type="line" height={height} />;
  return <ReactApexChart options={LineOptions} series={series} type="line" height={height} />;
};

export default Line;
